import { cva } from '@/styled-system/css';

export const adornedInputAdornmentRecipe = cva({
  base: {
    position: 'relative',
    color: 'AdornedInput.Adornment.default',
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  variants: {
    disabled: {
      true: {
        pointerEvents: 'none',
      },
      false: {
        '&:is(button, a, [role="button"])': {
          cursor: 'pointer',
          pointerEvents: 'auto',
        },
      },
    },
    size: {
      sm: {
        paddingBlock: 'AdornedInput.sm.padding.vert',
      },
      md: {
        paddingBlock: 'AdornedInput.md.padding.vert',
      },
      lg: {
        paddingBlock: 'AdornedInput.lg.padding.vert',
      },
    },
  },
});
